import {DomainObject} from 'shared/store';
import { computed, observable, makeObservable } from 'mobx';
import {dateSpan, dateFormatter} from 'shared/tools';
import {formatTimeOffAmount} from 'main/tools';
import TimeOffType from './TimeOffType';

class TimeOffLiabilityBalance extends DomainObject {
  id;
  accrualAdjustmentPeriodStartDate;
  accrualAdjustmentPeriodEndDate;
  lastDayOfWork;
  available;
  scheduled;
  accrualAdjustment;
  totalLiability;
  type = {};

  _relations = {
    type: TimeOffType,
    _dates: ['accrualAdjustmentPeriodStartDate', 'accrualAdjustmentPeriodEndDate', 'lastDayOfWork']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      accrualAdjustmentPeriodStartDate: observable,
      accrualAdjustmentPeriodEndDate: observable,
      lastDayOfWork: observable,
      available: observable,
      scheduled: observable,
      accrualAdjustment: observable,
      totalLiability: observable,
      type: observable,
      availableView: computed,
      scheduledView: computed,
      absoluteAccrualAdjustmentView: computed,
      totalLiabilityView: computed,
      lastDayOfWorkView: computed,
      accrualAdjustmentPeriodDateRange: computed
    });

    this.merge(other);
  }

  get availableView() {
    return formatTimeOffAmount(this.available, this.type.unit);
  }

  get scheduledView() {
    return formatTimeOffAmount(this.scheduled, this.type.unit);
  }

  get absoluteAccrualAdjustmentView() {
    return formatTimeOffAmount(Math.abs(this.accrualAdjustment), this.type.unit);
  }

  get totalLiabilityView() {
    return formatTimeOffAmount(this.totalLiability, this.type.unit);
  }

  get lastDayOfWorkView() {
    return dateFormatter(this.lastDayOfWork);
  }

  get accrualAdjustmentPeriodDateRange() {
    return dateSpan(this.accrualAdjustmentPeriodStartDate, this.accrualAdjustmentPeriodEndDate, true);
  }
}

export default TimeOffLiabilityBalance;
